module.exports = __webpack_public_path__ + "media/images/recruitment/pinterest/pinterest-2-4fea595defee0d9e9ef1a6ee808d78cb.jpg";